import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ModalService } from '@usitsdasdesign/dds-ng/modal';

@Component({
  selector: 'app-welcome-popup',
  templateUrl: './welcome-popup.component.html',
  styleUrl: './welcome-popup.component.less'
})
export class WelcomePopupComponent {
  
  constructor(private modalService: ModalService){

  }

  closeModal() {
     this.modalService.close();
  }
}
